var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKdb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 96,
    viewBox: "0 0 231 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3106_24647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.872 36.0369V39.8177H196.125V36.0369H194.163V46.4566H196.125V41.529H197.872V46.8329H199.834V36.0369H197.872ZM192.917 47.5496C189.146 47.5496 186.073 49.3863 186.073 51.644C186.073 53.9018 189.146 55.7385 192.917 55.7385C196.689 55.7385 199.753 53.9018 199.753 51.644C199.753 49.3863 196.689 47.5496 192.917 47.5496ZM192.909 54.0451C190.274 54.0451 188.133 52.97 188.133 51.644C188.133 50.3181 190.274 49.234 192.909 49.234C195.543 49.234 197.693 50.3181 197.693 51.644C197.693 52.97 195.552 54.0451 192.909 54.0451ZM156.552 49.664H147.556V47.4959H145.451V54.2512C145.451 54.7888 145.953 55.2367 146.535 55.2367H158.648V47.4959H156.56V49.664H156.552ZM156.534 53.5345H147.556V51.3573H156.534V53.5345ZM156.552 39.8446H152.574C152.117 37.6137 150.02 36.001 147.565 36.001C144.752 36.001 142.458 38.1154 142.458 40.7226C142.458 43.3298 144.752 45.4352 147.565 45.4352C150.047 45.4352 152.153 43.8046 152.583 41.5469H156.552V46.1878H158.639V36.0369H156.552V39.8446ZM147.565 43.7777C145.935 43.7777 144.6 42.407 144.6 40.7316C144.6 39.0562 145.926 37.6764 147.565 37.6764C149.205 37.6764 150.531 39.0472 150.531 40.7316C150.531 42.4159 149.205 43.7777 147.565 43.7777ZM167.383 49.1354H165.296V54.2602C165.296 54.7977 165.798 55.2547 166.38 55.2547H179.075V53.5434H167.383V49.1354ZM163.128 47.6392H180.616V45.928H163.128V47.6392ZM171.872 44.2526C175.716 44.2526 178.842 42.2995 178.842 39.8894C178.842 37.4793 175.716 35.5352 171.872 35.5352C168.028 35.5352 164.911 37.4883 164.911 39.8894C164.911 42.2905 168.037 44.2526 171.872 44.2526ZM171.872 37.2285C174.578 37.2285 176.773 38.429 176.773 39.8984C176.773 41.3677 174.578 42.5772 171.872 42.5772C169.166 42.5772 166.971 41.3766 166.971 39.8984C166.971 38.4201 169.166 37.2285 171.872 37.2285Z",
    fill: "#153774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.718 46.376C123.823 45.3368 125.508 43.733 126.475 41.8337L126.412 41.7978L126.484 41.8337V41.8068L126.502 41.8337C127.461 43.733 129.154 45.3368 131.259 46.376L132.236 45.0411C131.116 44.396 129.602 43.2582 128.59 41.5022C127.613 39.7282 127.55 37.6317 127.55 37.0942V36.4043H125.418V37.1031C125.418 37.6586 125.355 39.7461 124.379 41.5111C123.375 43.2671 121.861 44.396 120.741 45.0501L121.718 46.385V46.376Z",
    fill: "#153774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.332 48.5986H124.245V54.2699C124.245 54.8164 124.746 55.2644 125.338 55.2644H137.298V53.5531H126.332V48.5986Z",
    fill: "#153774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.092 36.0547H135.004V50.0133H137.092V42.6129H139.959V40.9017H137.092V36.0547Z",
    fill: "#153774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0785 36.7539H77.8442L77.8263 36.7808L68.5892 45.319V36.7629H66.4121V55.246H68.5892V46.5465L78.8029 55.246H82.2612L70.9903 45.8924L81.0785 36.7539Z",
    fill: "#153774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.762 45.6774C115.159 45.0144 116.539 43.7691 116.539 41.4486V41.3948C116.539 40.2033 116.109 39.2088 115.339 38.4024C114.272 37.3631 112.597 36.7539 110.492 36.7539H102.607V55.246H110.832C114.855 55.246 117.561 53.3645 117.561 50.166V50.1123C117.561 47.6305 115.867 46.3404 113.762 45.6774ZM104.874 46.9138H110.519C113.699 46.9138 115.321 48.0516 115.321 49.9868V50.0406C115.321 52.0385 113.645 53.2391 110.886 53.248H104.802V38.7698H110.303C112.911 38.7698 114.281 39.9255 114.29 41.6905V41.7353C114.29 43.8407 112.624 44.9338 110.151 44.9427H106.057L104.874 46.9228V46.9138Z",
    fill: "#153774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1005 36.7539H83.6587V55.246H90.1005C93.0033 55.246 95.4581 54.2336 97.1873 52.5761C98.9164 50.9186 99.9199 48.6071 99.9199 46.0089V45.9551C99.9199 43.3569 98.9164 41.0544 97.1873 39.4059C95.4581 37.7574 93.0033 36.7629 90.1005 36.7629V36.7539ZM97.6263 46.0537C97.6263 50.0764 94.7056 53.1853 90.1005 53.1853H85.8806V38.8235H90.1005C94.6966 38.8235 97.6263 41.9772 97.6263 46.0089V46.0447V46.0537Z",
    fill: "#153774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8817 38.877C36.3083 40.0058 36.8907 42.3442 37.6164 43.4641L47.5075 58.9907H40.2773C39.1395 58.9907 38.0195 58.3366 37.5357 57.5841L32.1333 49.1175C31.6226 48.3291 31.6495 47.0747 32.1333 46.3042L36.8817 38.877Z",
    fill: "url(#paint0_radial_3106_24647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.057 46.5286C40.7971 46.9407 40.5552 47.9173 40.9584 48.7146L37.6166 43.4734C36.8998 42.3535 36.3175 40.0151 36.8819 38.8862L37.4732 37.9545C38.0108 37.1033 39.0053 36.5479 40.2685 36.5479H47.3733L41.048 46.5375L41.057 46.5286Z",
    fill: "url(#paint1_radial_3106_24647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7415 53.1137C56.3149 51.9848 55.7325 49.6465 55.0158 48.5265L45.1157 33H52.3459C53.4837 33 54.6037 33.6451 55.0875 34.3977L60.481 42.8732C60.9917 43.6616 60.9648 44.9159 60.481 45.6775L55.7415 53.1048V53.1137Z",
    fill: "url(#paint2_radial_3106_24647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.566 45.4624C51.8258 45.0503 52.0677 44.0737 51.6646 43.2764L55.0064 48.5176C55.7231 49.6375 56.3055 51.9759 55.7321 53.1048L55.1408 54.0365C54.6032 54.8877 53.6087 55.4431 52.3455 55.4431H45.2407L51.566 45.4535V45.4624Z",
    fill: "url(#paint3_radial_3106_24647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.685 37.5151H189.056V35.7949H186.96V37.5151H183.269V39.1547H185.105L184.989 39.2532C184.129 40.0237 183.654 41.063 183.654 42.165C183.654 44.3959 185.607 46.2146 188.017 46.2146C190.427 46.2146 192.38 44.3959 192.38 42.165C192.38 41.063 191.905 40.0237 191.045 39.2532L190.929 39.1547H192.694V37.5151H192.685ZM188.017 44.6199C186.7 44.6199 185.625 43.482 185.625 42.0754C185.625 40.6688 186.7 39.5399 188.017 39.5399C189.334 39.5399 190.409 40.6778 190.409 42.0754C190.409 43.4731 189.334 44.6199 188.017 44.6199Z",
    fill: "#153774"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3106_24647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9912 36.3033) rotate(-90) scale(19.1871 21.0145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CFE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9D2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ABCAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#98B9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#688EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#456EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#355C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153774"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3106_24647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6626 37.1419) scale(13.4941 13.4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CFE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9D2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ABCAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#98B9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#688EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#456EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#355C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153774"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3106_24647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6259 46.8422) rotate(90) scale(19.1834 21.0104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CFE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9D2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ABCAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#98B9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#688EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#456EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#355C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153774"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3106_24647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3742 52.6635) rotate(180) scale(13.4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CFE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9D2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ABCAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#98B9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#688EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#456EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#355C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153774"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3106_24647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168.068,
    height: 26,
    fill: "white",
    transform: "translate(31.7661 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdb);
export default __webpack_public_path__ + "static/media/kdb.9e93bbe3ecae4536fe6b88dfb8adabcd.svg";
export { ForwardRef as ReactComponent };